<template>
    <div class="pb-5">
        <header class="bgImage masthead"
            :style="'background: linear-gradient(to bottom, rgba(72, 1, 90, 0.6), rgba(45, 4, 52, 1)), url(' + styleLink() + ') no-repeat center; background-size: cover;'">
            <mainMenu/>
            <!-- <div class="menu-nav-bar">
                <div class="container">
                    <b-navbar toggleable="lg" type="dark">
                        <b-navbar-brand href="/">Д<b-icon icon="patch-question-fill" font-scale="1"
                                variant="light"></b-icon>С</b-navbar-brand>
                        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                        <b-collapse id="nav-collapse" is-nav>
                            <b-navbar-nav class="ms-auto">
                                <b-nav-item v-if="!$store.getters.AUTHORIZE" :to="{ path: '/' }">Вход</b-nav-item>
                                <b-nav-item v-if="$store.getters.AUTHORIZE" :to="{ path: '/personalcabinet' }">Личный
                                    кабинет</b-nav-item>
                                <b-nav-item v-if="$store.getters.AUTHORIZE" :to="{ path: '/grades' }">Оценки</b-nav-item>
                                <b-nav-item href="/contact">Контакты</b-nav-item>
                                <b-nav-item v-if="$store.getters.AUTHORIZE" @click="logOut()">Выход</b-nav-item>
                            </b-navbar-nav>
                        </b-collapse>
                    </b-navbar>
                </div>
            </div> -->
            <div class="container">
                <div class="row">
                    <div class="col-lg-10 col-md-10 mx-auto">
                        <div class="site-heading">
                            <div v-if="$route.path === '/personalcabinet/' || $route.path === '/personalcabinet'">
                                <h1>Личный кабинет</h1>
                            </div>
                            <div v-else-if="$route.path === '/grades/' || $route.path === '/grades'">
                                <h1>{{ name }}</h1>
                            </div>
                            <div v-else>
                                <h2>{{ name }}</h2>
                                <h3>{{ description }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>
<script>
import md5 from 'js-md5'
import mainMenu from '@/components/mainMenu.vue'

export default {
    props: ['name', 'description'],
    // {
    //     textHeader: Object,
    //     descriptionHeader: Object,

    // },
    // watch: {
    //     $route: {
    //         handler: function () {
    //             this.titleUpdate()
    //         }
    //     },
    //     deep: true
    // },
    components: {
        mainMenu
    },
    watch: {
        name: function (newVal, oldVal) { // watch it
            if ((newVal !== oldVal)
                && (this.$route.path != '/personalcabinet/' && this.$route.path != '/personalcabinet')
                && newVal != undefined) {
                document.title = this.name;
            }
        },
        $route: {
            handler: function () {
                this.titleUpdate()
            }
        },
        deep: true
    },
    created() {
        this.titleUpdate()
    },
    methods: {
        styleLink() {
            if (this.$route.params.partId)
                return this.$store.getters.URL + '/public/materials/' + md5(this.$route.params.partId) + '/' + this.$route.params.partId + '.jpg';
            else return this.$store.getters.URL + '/public/images/home-bg.jpg';
        },
        titleUpdate() {
            if (this.$route.path == '/personalcabinet/' || this.$route.path == '/personalcabinet') {
                document.title = 'Личный кабинет';
            }
            if (this.$route.path == '/grades/' || this.$route.path == '/grades') {
                document.title = 'Оценки';
            }
        },
        // logOut() {
        //     // this.$store.commit('authorize', false);
        //     this.setLogOut();
        //     // this.$store.commit('reDirect', '/');
        // },
        // setLogOut() {
        //     this.axios
        //         .get(this.$store.getters.URL + '/account/logout')
        //         .then(response => (this.$store.commit('reDirect', response.data.redirect),
        //             this.$store.commit('authorize', false)
        //         ));
        // },
    }
}
</script>
<style>
.bgImage .site-heading {
    padding: 60px 0 120px 0;
}

.bgImage .site-heading h2,
.bgImage .site-heading h3 {
    color: white;
}

header.masthead .page-heading .subheading,
header.masthead .site-heading .subheading {
    font-size: 24px;
    font-weight: 300;
    line-height: 1.1;
    display: block;
    margin: 10px 0 0;
    font-family: Arial, sans-serif;
    color: white;
}

@media only screen and (min-width:768px) {

    header.masthead .page-heading h1,
    header.masthead .site-heading h1 {
        font-size: 60px;
        color: white;
    }
}

#app .navbar-brand {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 26px;
    font-weight: 900;
}

nav {
    padding: 0;
}


#app .nav-link {
    color: #d5d5d5;
}

#app .nav-link:hover {
    color: #d5d5d5;
}

#app .nav-item .router-link-exact-active {
    color: #ffffff;
}

#nav-collapse {
    position: relative;
    min-height: 50px;
    margin-bottom: 20px;
    border: 1px solid transparent;
}

.menu-nav-bar {
    /* position:static; */
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
}
</style>